/**
 * AdminWrapper Component
 * 
 * Wraps the admin component which has its own Router (v5)
 * This prevents router conflicts with the main app's v6 Router
 * 
 * The admin.min.js exports an admin app that has its own
 * BrowserRouter and Route elements (v5 style)
 */

import React from "react";

/**
 * Wrapper component for admin
 * Simply renders the admin component in a way that isolates its router
 */
const AdminWrapper = ({ AdminComponent, match }) => {
  return (
    <div className="admin-wrapper">
      {/* Admin component has its own Router, so we don't wrap it */}
      <AdminComponent match={match} />
    </div>
  );
};

export default AdminWrapper;
